export const LogoAccent = ({ accent }) => {
  const hat = accent === "santa_hat";
  const css = `
[data-testid="navbar-logo-link"]{position:relative}
[data-testid="navbar-logo-link"]::before{content:"";position:absolute;z-index:2;pointer-events:none;
background:url(/accents/${accent}.png) center/contain no-repeat;width:${hat ? 34 : 24}px;height:${hat ? 26 : 24}px;
left:${hat ? -9 : -10}px;top:${hat ? -8 : -6}px;transform:rotate(${hat ? -22 : -12}deg);filter:drop-shadow(0 1px 1px rgba(0,0,0,.25));
animation:accent-pop .6s cubic-bezier(.34,1.56,.64,1) both}
@media (min-width:640px){[data-testid="navbar-logo-link"]::before{width:${hat ? 48 : 32}px;height:${hat ? 37 : 32}px;left:${hat ? -8 : -10}px;top:${hat ? -2 : 0}px}}
@keyframes accent-pop{from{opacity:0;transform:scale(.4) rotate(-40deg)}}`;
  return <style data-testid="logo-accent">{css}</style>;
};
